import React, { Fragment, useEffect, useState } from 'react';
import { oEmbedResponseRich } from 'types/oembed';

import { TIKTOK_ENDPOINT, TIKTOK_OEMBED_LIB } from '../constants';

interface IProps {
  url: oEmbedResponseRich['author_url'];
}

export const EmbedTikTok = ({ url }: IProps) => {
  const [embed, setEmbed] = useState({ loaded: false, html: '' });

  useEffect(() => {
    void handleEmbed();
    return () => removeEmbed();
  }, []);

  /*
   * TikTok js library does not expose methods to manually render oEmbed instance.
   * Force the render to initialize by removing and adding to the head for every
   * embed rendered on the current view. Do this AFTER the html is rendered.
   */
  useEffect(() => {
    removeScriptFromHead();
    addScriptToHead();
  }, [embed.loaded]);

  function removeScriptFromHead() {
    document.head.querySelectorAll('script').forEach(value => {
      if (value.src === TIKTOK_OEMBED_LIB) {
        document.head.removeChild(value);
      }
    });
  }

  function addScriptToHead() {
    const script = document.createElement('script');
    script.src = TIKTOK_OEMBED_LIB;
    document.head.appendChild(script);
  }

  function removeEmbed() {
    setEmbed({ loaded: false, html: '' });
  }

  async function handleEmbed() {
    try {
      const response = await fetch(`${TIKTOK_ENDPOINT}?url=${url}`);
      const { html }: oEmbedResponseRich = await response.json();
      setEmbed({ loaded: true, html: html.substr(0, html.indexOf('<script')) });
    } catch (error) {
      throw new Error(error as string);
    }
  }

  return <Fragment>{<div dangerouslySetInnerHTML={{ __html: embed.html }} />}</Fragment>;
};

export default EmbedTikTok;
